/* import __COLOCATED_TEMPLATE__ from './form.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';

export default Component.extend({
  attributeService: service(),

  qualificationAttributesAsFullAttributes: computed(
    'qualificationAttributes.@each.identifier',
    'attributeIdentifiers',
    function () {
      let identifiers =
        this.attributeIdentifiers || this.qualificationAttributes.mapBy('identifier');
      return this.attributeService.findByIdentifiers(identifiers);
    },
  ),
});
